import { render } from "./PortfolioComponents.vue?vue&type=template&id=44c89354"
import script from "./PortfolioComponents.vue?vue&type=script&lang=js"
export * from "./PortfolioComponents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__